"use client";

import React from "react";
import { Smartphone, MapPin, UserCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Focused 1-on-1 Care",
  description: "Elite care, zero hand-offs. Every session is a full hour of 1-on-1 attention with Dr. Dave Garaffa. In a world of crowded clinics and assistants, I provide the doctoral-level focus you need to reach your goals faster.",
  icon: UserCheck
}, {
  title: "Mobile Direct Access",
  description: "No doctor's script required in NJ. We bring the high-performance clinic directly to your home or office in Monmouth County, saving you time and travel.",
  icon: MapPin
}, {
  title: "Integrated Rehab App",
  description: "24/7 access to your custom recovery program via our digital platform. Stay connected with Dr. Dave and track your progress between your physical sessions.",
  icon: Smartphone
}];
export default function TheConciergeEdge() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="172781" id="the-concierge-advantage" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-28">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
        <svg className="absolute inset-0 h-full w-full stroke-secondary/20" aria-hidden="true">
          <defs>
            <pattern id="concierge-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 40V.5H40" fill="none" strokeDasharray="2 2" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" strokeWidth="0" fill="url(#concierge-grid)" />
        </svg>
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mx-auto max-w-2xl text-center mb-16 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl font-bold tracking-tight text-primary sm:text-4xl md:text-5xl mb-6">
            The Concierge Advantage
          </h2>
          <p className="text-lg text-muted-foreground md:text-xl">Experience elite physical therapy and performance coaching designed for high performers. No insurance restrictions, no waiting rooms - just results.</p>
        </div>

        <div ref={gridRef} className="grid gap-12 lg:grid-cols-3">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 transform ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full bg-card/50 backdrop-blur-sm border-border hover:border-secondary/50 shadow-sm hover:shadow-lg transition-all duration-300">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary/10 text-secondary">
                      <Icon className="h-6 w-6" />
                    </div>
                    <CardTitle className="text-xl text-primary font-bold">{feature.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}